
import { Vue, Component } from 'vue-property-decorator'
import Delivery from '@/types/delivery'
import TextEditor from '@/components/base/TextEditor.vue'
import moment from 'moment'
import 'moment/locale/nl'
import DeliveryDetailsRow from '@/views/delivery/components/DeliveryDetailsRow.vue'
import DeliveryContractorsRow from '@/views/delivery/components/DeliveryContractorsRow.vue'
import DeliveryEntityRow from '@/views/delivery/components/DeliveryEntityRow.vue'
import DeliveryStatusRow from '@/views/delivery/components/DeliveryStatusRow.vue'
import DeliveryGeneralCheckRow from '@/views/delivery/components/DeliveryGeneralCheckRow.vue'
moment.locale('nl')

@Component({
  components: { DeliveryGeneralCheckRow, DeliveryStatusRow, DeliveryEntityRow, DeliveryContractorsRow, DeliveryDetailsRow, TextEditor }
})

export default class DeliveryShowGeneralChecksCard extends Vue {
  settings = {
    routeNames: { list: 'deliveries', show: 'deliveryShow', edit: 'deliveryEdit' },
    routeParamKey: 'deliveryId',
    functionNames: { setCurrent: 'setCurrentDelivery', save: 'saveDelivery' },
    getterNames: { current: 'currentDelivery', loading: 'loadingDelivery', errors: 'deliveryErrors' }
  }

  get currentItem () : Delivery {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }
}
